// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fr","advertDetailContactGroup__header":"c-n_fs","advertDetailContactGroup__value":"c-n_ft"};